import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Slide
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogCloseRenewal = (props) => {
  return (
    <Dialog
      aria-labelledby="approval-required-title"
      aria-describedby="approval-required-description"
      open={props.open}
      onClose={props.onClose}
      TransitionComponent={Transition}
      className="dialog-wrapper"
    >
      <DialogTitle id="approval-required-title" className="dialog-title">
        {props.intl.formatMessage({
          id: 'close_renewal'
        })}{' '}
      </DialogTitle>
      <DialogContent>
        <p id="approval-required-description" className="dialog-text">
          {props.intl.formatMessage({
            id: 'close_renewal_paragraph'
          })}{' '}
        </p>
        <hr />
      </DialogContent>
      <DialogActions className="dialog-action-buttons">
        <span className="btn-secondary-action">
          <Button onClick={props.onClose} color="primary">
            {' '}
            {props.intl.formatMessage({
              id: 'cancel'
            })}
          </Button>
        </span>
        {!props.hideAccept ? (
          <span className="btn-action">
            <Button onClick={props.onAccept} color="primary">
              {props.intl.formatMessage({
                id: 'yes_Close_this_renewal'
              })}
              <Icon>delete_forever</Icon>
            </Button>
          </span>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

DialogCloseRenewal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  hideAccept: PropTypes.bool
};

export default injectIntl(DialogCloseRenewal);
